import React from 'react'
import { Input, Textarea, Toggle } from '@base'
import { strings } from '@constants'
import { displayAmount } from '@utils'
import { Spacings } from '@styles'
import { Amount, DesktopAmountSection, FlexWrapper, Heading, InfoPanel, Label, PartialAmountWrapper, Sign, TotalAmountSection } from '../../style'


const AmountSection = ({
	state2,
	isScrap,
	isQuoteTypeX,
	valueChangeHandler,
	isLogisticsQuoteType,
	setIsLogisticsQuoteType,
	staticData,
	renderStaticMessages,
	setQuoteType,
}) => {
	const setLogisticsQuoteType = (type) => (e) => {
		e.stopPropagation()
		if (isLogisticsQuoteType === type) return
		setIsLogisticsQuoteType(type)
	}

	return (
		<DesktopAmountSection>
			<TotalAmountSection>
				<FlexWrapper>
					<Label>{strings('select_quote_type')}</Label>
					{isScrap ? (
						<Toggle
							options={[
								{
									label: strings('for'),
									click: setQuoteType('FOR'),
									active: !isQuoteTypeX,
								},
							]}
						/>
					) : (
						<Toggle
							options={[
								{
									label: strings('for'),
									click: setQuoteType('FOR'),
									active: !isQuoteTypeX,
								},
								{
									label: strings('x'),
									click: setQuoteType('EX'),
									active: isQuoteTypeX,
								},
							]}
						/>
					)}
				</FlexWrapper>
			</TotalAmountSection>
			{isQuoteTypeX && (
				<InfoPanel show>
					{renderStaticMessages()}
					<br />
					<Heading>{strings('total_amount_breakup')}</Heading>
					<PartialAmountWrapper>
						<Label>{strings('quoted_amount_x')}</Label>
						<Amount>{displayAmount(staticData.totalExPrice)}</Amount>
					</PartialAmountWrapper>
					<Sign>+</Sign>

					<PartialAmountWrapper>
						<TotalAmountSection>
							<FlexWrapper>
								<Label>{strings('select_quote_type')}</Label>
								<Toggle
									options={[
										{
											label: strings('cost_per_mt'),
											click: setLogisticsQuoteType('MT'),
											active: isLogisticsQuoteType === strings('mt'),
										},
										{
											label: strings('lumpsum'),
											click: setLogisticsQuoteType('LUMPSUM'),
											active: isLogisticsQuoteType === strings('lumpsum'),
										},
									]}
								/>
							</FlexWrapper>
						</TotalAmountSection>
						{isLogisticsQuoteType === strings('mt') ? (
							<Input
								id='quote-logistics-quote'
								label={strings('label_logistics_quotation_per_mt')}
								type='number'
								min={0}
								placeholder={strings('placeholder_enter_logistics_quotation_per_mt')}
								value={state2.enquiryQuote?.logistics_quote_per_mt}
								onChange={valueChangeHandler(null, 'logistics_quote_per_mt')}
							/>
						) : (
							<Input
								id='quote-logistics-quote'
								label={strings('label_lumpsum_logistics_quotation')}
								type='number'
								min={0}
								placeholder={strings('placeholder_enter_lumpsum_logistics_quotation')}
								value={state2.enquiryQuote?.lumpsum_logistics_quote}
								onChange={valueChangeHandler(null, 'lumpsum_logistics_quote')}
							/>
						)}

						<Input
							id='quote-minimum_guaranteed_weight'
							label={strings(['mgw_full', '(', 'mgw', ')'])}
							type='number'
							placeholder={strings('placeholder_enter_value_in_kg')}
							value={state2.enquiryQuote?.minimum_guaranteed_weight}
							onChange={valueChangeHandler(null, 'minimum_guaranteed_weight')}
						/>
					</PartialAmountWrapper>
					<Sign>=</Sign>
					<PartialAmountWrapper>
						<Label>{strings('total_amount_for')}</Label>
						<Amount>{displayAmount(staticData.totalAmount)}</Amount>
					</PartialAmountWrapper>
					<PartialAmountWrapper>
						<Textarea
							id='quote-message'
							label={strings('message')}
							type='text'
							rows={3}
							placeholder={strings('msg_share_any_more_details')}
							value={state2.enquiryQuote?.message}
							onChange={valueChangeHandler(null, 'message')}
						/>
					</PartialAmountWrapper>
				</InfoPanel>
			)}
			{!isQuoteTypeX && (
				<InfoPanel show>
					{renderStaticMessages()}
					<PartialAmountWrapper margin={Spacings.SPACING_4B}>
						<Label>{strings('total_amount_for')}</Label>
						<Amount>{displayAmount(staticData.totalAmount)}</Amount>
					</PartialAmountWrapper>
					<PartialAmountWrapper>
						<Textarea
							id='quote-message'
							label={strings('message')}
							type='text'
							rows={3}
							placeholder={strings('msg_share_any_more_details')}
							value={state2.enquiryQuote?.message}
							onChange={valueChangeHandler(null, 'message')}
						/>
					</PartialAmountWrapper>
				</InfoPanel>
			)}
		</DesktopAmountSection>
	)
}

export default AmountSection
